<template>
	<div class="w-100">
		<div class="import-beneficiarios">
			<div class="import-beneficiarios-items">
				<div class="importing-box">
					<div class="title px-0 mb-0">
						<h4 class="title-header optum-bold">Upload de Beneficiários para a Empresa {{ nomeEmpresa }}</h4>
						
						<p class="title-body ml-0">
							Escolha o serviço abaixo para o qual deseja realizar o upload da base de beneficiários, clique em “selecionar arquivo”, e depois clique no botão “validar base”.
						</p>
					</div>
					<div class="file-select mb-4">
						<form ref="formUpload">
							<b-form-group v-if="productOptions.length > 0" label-for="radio-contrato-options" class="input-40-filter-cases">
								<label class="label-produto">Serviço(s):</label>
								<b-form-radio-group id="radio-contrato-options" name="radio-contrato-options" v-model="productSelected"
								:options="productOptions" :state="validation.productSelected" stacked/> 
								<b-form-invalid-feedback :state="validation.productSelected">
									{{messageError}}
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group>
						<input type="file" name="file" ref="file" @change="changeFile" accept=".csv, .xlsx, .txt" :disabled="importing"/>
						<b-button pill class="input-custon-file-button w-100 m-0 mb-2" :disabled="importing">
								<template v-if="!file">
									<label @click="openFileInput" class="w-100 text-center">Selecionar arquivo</label>
								</template>
								<template v-else>
									<label style="display: flex; justify-content: space-between;">
										<span class="badge-custon-filename">{{file.name}}</span>
										<span class="badge-custon-icon" @click="removeFile"> <b-icon icon="x" scale="1"></b-icon> </span>
									</label>
								</template>
								</b-button>
								<b-form-invalid-feedback :state="validation.fileEmpty">
									{{messageError}}
								</b-form-invalid-feedback>
							</b-form-group>
						</form>
						<p class="file-advise" :class="{'invalid': isFileTypeInvalid}">
							Arquivos permitidos para upload: .xlsx, .csv e .txt com dados separados por ponto e vírgula (;)
						</p>
						<div class="upload-status" v-if="importing">
							<b-spinner small type="grow"></b-spinner>
							<span>Upload em processamento. Aguarde a conclusão.</span>
						</div>
					</div>
					<div class="advise-continue-load" v-if="continueLostImport && !importing">
						Selecione o arquivo {{importacao.fileName}} para continuar a importação na linha {{importacao.lastLine}}
					</div>
					<div class="buttons-head">
						<div v-show="rowsJson &&!importing">
							<b-button pill class="btn-base cancelar-importacao optum-bold" @click="$bvModal.show('cancelar-import-beneficiario')" v-if="continueLostImport">Cancelar Importação</b-button>
						</div>
						<div class="buttons-down">
							<b-button pill class="btn-base outline-primary-btn optum-bold" @click="downloadModelo" :disabled="importing">Baixar modelo</b-button>
							<b-button pill class="btn-base primary-btn optum-bold" @click="beforeUpload" :disabled="isFileTypeInvalid || importing">Validar base</b-button>
						</div>
					</div>
				</div>
			</div>
			<ModalSelecionarEmpresaBeneficiario @update-empresa="updateEmpresa" v-if="!closedModal" />

			<b-modal id="modal_file_format_error" centered hide-footer body-class="pt-2" no-close-on-backdrop no-stacking no-close-on-esc @close="finalizarImportacao">
				<DynamicIcon icon="not" :classString="'alert-exclamation'"/>
					<p class="mb-6">{{ responseMessage }}</p> <br/><br/>
				<b-button pill class="btn-base outline-primary-btn optum-bold" @click="downloadModelo">Baixar modelo</b-button>
			</b-modal>

			<b-modal id="pre-import-beneficiarios-success" centered hide-footer 
			header-class="pre-import-beneficiarios-sub-header" body-class="pre-import-beneficiarios-sub-body">
				<DynamicIcon icon="check" :classString="'alert-exclamation'"/>
				Beneficiários pré importados com sucesso!
			</b-modal>

			<b-modal id="iniciar-importacao-success" centered hide-footer body-class="pt-2" no-close-on-backdrop no-stacking no-close-on-esc>
				<template #modal-header>
						<div class="modal-title-flex-bene ">
							<div class="modal-title-content-bene ">
								<DynamicIcon icon="check" classString="icon-tittle-bene"/>
								<span class="modal-title-text-bene">Iniciar importação</span>  
							</div>
						</div>
				</template>	
            
				Escolha o tipo de importação abaixo:

				<div class="col-12 p-0">
                    <a @click="selectType('IMPORT_REPLACE')">
                        <div class="select-tipo-importacao">
                            <h5>Full - Substituir a base de beneficiários</h5>
							<p>O sistema vai inativar os beneficiários que não constam na nova base importada.</p>
                        </div>
                    </a>
				<a @click="selectType('IMPORT_CONCAT')" v-if="notExistsTravaImportacao">
                        <div class="select-tipo-importacao">
							<h5>Incremental - Adicionar à base de beneficiários</h5>
                            <p>A base de beneficiários atual será mantida e os novos beneficiários serão adicionados a ela.</p>
                        </div>
                    </a>
                </div>
		</b-modal>
		</div>
	</div>
	
</template>

<script>
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import EmpresaResource from "@/resources/EmpresaResource"
import HomeResource from "@/resources/HomeResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ModalSelecionarEmpresaBeneficiario from "./ModalSelecionarEmpresaBeneficiario.vue"
import Validations from "@/util/Validations";

import estruturaPorCPF from "../config/estrutura-colunas"
import headerFields from "../config/header-colunas"
import excelParser from "../utils/excel-parser"
import csvParser from "../utils/csv-parser"

let emptyImportState = {
	/**
	 * parser source
	 */
	file: null,

	/**
	 * json table exibition and data update send
	 */
	lineStart: 2,
	jsonLinesSize: 150,
	rowsJson: null,
	parser: null,

	/**
	 * import status
	 */
	importing: false,
	lastBatch: false,
	hideTable: false
}

export default {
	name: "UploadBeneficiarios",
	components:{
		DynamicIcon,
		ModalSelecionarEmpresaBeneficiario,
	},
	props: {
		importacao: Object,
		continueLostImport: Boolean
	},
	data() {
		return {
			/**
			 * Configurations
			 */
			config: {
				estruturaColunas: estruturaPorCPF
			},
			headerFields: headerFields,
			dateFields: ["dataNascimento", "dataAdmissao"],
			empresa: null,
			nomeEmpresa: null,
			forceUploadFile: false,
			responseMessage: null,
			validation : {
				productSelected: null,
				fileEmpty: null
			},
			closedModal: false,
			messageError: null,
			productSelected: null,
			productOptions: [],
			...emptyImportState,
			typeImportacao: null,
			notExistsTravaImportacao: true
		}
	},
	computed: {
		isFileTypeInvalid() {
			if (!this.file)
				return false

			return !this.isCSV() && !this.file.name.toUpperCase().endsWith(".XLSX")
		}
	},
    methods: {
		changeFile(event) {
			if (!event.target || !event.target.files) {
				return
			}

			this.file = event.target.files[0]

			let parser = this.isCSV() ? csvParser : excelParser

			parser(this)
			.then(parser => {
				this.parser = parser
				this.parserLines(this.lineStart)
			})
			.catch(error => {
				console.error(error)
			})
		},
		isCSV() {
			return this.file.name.toUpperCase().endsWith(".CSV") || this.file.name.toUpperCase().endsWith(".TXT")
		},
		isInvalidForm()
		{
			if(this.productSelected == null)
			{
				this.validation.productSelected = false
				this.messageError = "Campo obrigatório!"
				return true;
			}

			if(this.file == null)
			{
				this.validation.fileEmpty = false
				this.messageError = "Campo obrigatório!"
				return true;
			}

			return false;
		},
		beforeUpload() {
			if(this.isInvalidForm()) return;

			EmpresaResource.getTravaImportacao(this.empresa, this.productSelected, {showLoader: false}).
			then(result => {
				if(result.ativo == 1) {
					this.notExistsTravaImportacao = false
				}
				this.$bvModal.show('iniciar-importacao-success')
			})
		},
		upload(){
			//if the file is bigger then 50kb, upload ao file. Other wise, upload by batch
			let kbSize = this.file.size / 1024
			let kbMax = this.isCSV() ? 50 : 200//70

			if ( kbSize > kbMax || this.forceUploadFile ) {
				this.uploadFile()
			}
			else {
				this.startBachImporting()
			}
		},
		uploadFile() {
			BeneficiarioImportacaoResource.uploadFile(this.$refs.formUpload, this.empresa, this.productSelected, this.typeImportacao,  {showLoader: true})
			.then((importacao) => {
				this.$emit("updateImportacao", importacao)
			})
			.catch((err) => {
				this.errorImportacao(err)
			})
		},
		startBachImporting() {
			this.importing = true

			this.sendBach()
			.catch((err) => {
				this.errorImportacao(err)
			})
		},
		sendBach() {
			let formData  = new FormData();
			formData.append("file", this.file)
			formData.append("batch", JSON.stringify({
				importacaoId: this.importacao.id,
				lastBatch: this.lastBatch,
				beneficiarios: this.rowsJson,
				empresa: this.empresa,
				produto: this.productSelected,
				tipo: this.typeImportacao,
				fileName: this.file.name
			}))

			return BeneficiarioImportacaoResource.sendBach(formData)
			.then((importacao) => {
				this.$emit("updateImportacao", importacao)

				if (this.lastBatch) {
					this.importing = false
                    this.$bvModal.show('pre-import-beneficiarios-success')
				}
				else {
					this.parserLines(this.lineStart + this.jsonLinesSize)
					this.hideTable = true
					this.$nextTick(() => {
						this.hideTable = false
						this.sendBach()
					})
				}
			})
		},
		parserLines(lineStart) {
			this.lineStart = lineStart

			let result = this.parser(lineStart)

			this.rowsJson = result.list
			this.lastBatch = result.lastBatch
		},
		updateEmpresa(empresa) {
			this.nomeEmpresa = empresa.text
			this.empresa = empresa.id
			this.closedModal = true	
			this.changeContratoOptions()
					
		},
		changeContratoOptions()
		{
			EmpresaResource.contratoOptions(this.empresa, {showLoader: true})
			.then(result => {
				if(Array.isArray(result))
				{	
					this.productOptions = result.map(elem =>  Object.create({'value': elem.id, 'text': elem.text }) )
				}
			})
		},
		downloadModelo()
		{
			HomeResource.downloadModelo()
		},
		openFileInput () {
			if (this.importing) {
				return
			}

			if(this.file == null) {
				this.$refs.file.click()
			}
		},
		removeFile()
		{
			this.$refs.file.value = ""
			this.file = null
		},
		selectType( type ){
			this.typeImportacao = type
			this.$bvModal.hide("iniciar-importacao-success")
			this.upload()
		},
		errorImportacao(err)
		{
			this.responseMessage = Validations.getMessageError(err.errors[0])
			this.$bvModal.show('modal_file_format_error')
			this.importing = false
		},
		finalizarImportacao() {
			BeneficiarioImportacaoResource.getImportacaoAtiva({showLoader: true})
			.then((importacao) => {
				if (!importacao || !importacao.id) {
					return
				}

				BeneficiarioImportacaoResource
				.deletarImportacao(importacao.id, {showLoader: true})
				.then(() => this.$router.go(0))
			})
		}
    },
	created() {
		if (this.importacao.lastLine)
		{
			this.lineStart = this.importacao.lastLine //case stop and back to continue
		}
	},
	watch: {
		"importacao.id": function (value) {

			if (!value) {
				for (let key in emptyImportState) {
					this[key] = emptyImportState[key]
				}
			}
		}
	}
}
</script>

<style scoped>
.import-beneficiarios {
	width: 70%;
	margin-left: auto;
	margin-right: auto;
	justify-content: space-between;
    color: #707070;
	font-size: 18px;
	text-align: left;
}

.title {
    margin-bottom: 30px;
    padding: 30px 20px;
	font-weight: 600;
    letter-spacing: 2.1px;
	font-size: 15px;
    justify-content: space-between;
	text-align: center;
}

.title-header {
	font-family: optum-sans-bold;
}
.title-header, .label-produto{
	color: #002677 !important;
	font-weight: bold !important;
}

.label-produto { 
	font-size: 14px !important;
	margin-bottom: 5px !important;
}

.title-body {
	text-align: center;
	font-weight: normal;
	margin: 1% 0 0 3%;
	line-height: 1.5;
    letter-spacing: 0.00938em;
    font-family: optum-sans;
    color: rgb(90, 90, 90);
    font-weight: 400;
    padding-top: 16px;
}
.import-beneficiarios .file-advise {
	padding-left: 10px;
    font-size: small;
}

.import-beneficiarios .file-advise.invalid {
	color: red;
}

.import-beneficiarios .upload-status {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 12px;
	color: #002677;
	font-weight: 600;
}

.file-select .file-name {
	margin-left: 5px;
}

.importing-box {
	width: 100%;
}

.advise-continue-load {
	margin-top: 30px;
	margin-bottom: 70px;
	text-align: center;
}

.importing-box .buttons-head {
	margin: 20px 0 3px 0;
	text-align: right;
}

.buttons-down {
	display: flex;
	justify-content:space-between;
}

.importing-box .buttons-head .iniciar-pre-importacao {
	margin-left: 5px;
}

.importing-box .buttons-head .loading  {
	float: right;
	margin-bottom: 10px;
}

.importing-box .buttons-head .loading .spinner-border {
	vertical-align: middle;
	margin-left: 5px;
}

.table-container .table-responsive {
	font-size: small;
}

@media (max-width: 930px) {
    .import-beneficiarios {
        flex-direction: column;
		width: 94%;
		margin-left: 3%;
    }

    .import-beneficiarios-items{
        margin-bottom: 10px;
    }
}

.modal-title-flex-bene  {
    width: 100% !important;
    display: flex;
    justify-content: space-between ;
    align-items: center;
}
.modal-title-content-bene  {
    display: flex;
    justify-content: flex-start ;
    align-items: center;
    gap: 17px;
}

.modal-title-text-bene {
	font-family: optum-sans-bold;
    font-weight: 700;
    font-size: 24px;
	line-height: 24px;
    color: rgb(0, 38, 119);
    text-align: left;
}

.icon-tittle-bene{
	height: 45px;
	margin-bottom: 0px !important;
}

.modal-header-p {
    margin: 0px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.00938em;
    font-size: 16px;
    color: rgb(90, 90, 90);
}

.select-tipo-importacao {
    text-align: left;
    width: 100%;
    border: 2px solid rgb(209, 209, 209);
    border-radius: 16px;
    padding: 8px;
    background-color: rgb(255, 255, 255);
    text-decoration: none;
    margin-top: 16px;
    font-weight: 400;
}

.select-tipo-importacao h5 {
	color:rgb(0, 38, 119);
}

.select-tipo-importacao:hover {
    border-color: rgb(0, 38, 119);
    background-color: rgb(217, 246, 250);;
}
</style>

<style>
.pre-import-beneficiarios-sub-header {
    padding-bottom: 5px !important;
}

.pre-import-beneficiarios-sub-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0px !important;
    text-align: center;
}

input[type=file] {
    background-color: aquamarine !important;
	border: none;
	visibility: hidden;
}

.input-100-filter-cases{
    width: calc(100% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-custon-file-button {
	background-color: #D9F6FA !important;
	border-radius: 20px;
	text-align: center;
	border: none !important;
	margin: -7.2% 0 0 -1%;
}

.input-custon-file-button label {
	text-transform: inherit !important;
	text-decoration: none !important;
	font-family: optum-sans-bold !important;
	font-size: 16px !important;
	font-weight: 700 !important;
	color: #002677 !important;
}

.input-custon-file-button:hover, .input-custon-file-button:focus {
	border: 2px solid #002677 !important;
	outline: none !important;
	box-shadow: none !important;
}

.badge-custon-filename {
	color: #707070;
	font-family: optum-sans;
	font-weight: normal;
}

.badge-custon-icon {
	font-family: "optum-sans";
	margin-left: 6px;
	color: #002677;
	border-radius: 50rem;
	cursor: pointer;
	padding: 2px;
}
.badge-custon-icon:hover {
	background-color: #fff;
	color: #002677;
}
</style>